export const onlyDigits = (value) => String(value ?? '').replace(/\D/g, '');

const applyMask = (value, mask) => {
  const digits = onlyDigits(value);
  if (!digits) return '';

  let result = '';
  let digitIndex = 0;

  for (let i = 0; i < mask.length && digitIndex < digits.length; i += 1) {
    if (mask[i] === '#') {
      result += digits[digitIndex];
      digitIndex += 1;
    } else {
      result += mask[i];
    }
  }

  return result;
};

export const formatCPF = (value) => {
  const digits = onlyDigits(value).slice(0, 11);
  return applyMask(digits, '###.###.###-##');
};

export const formatCNPJ = (value) => {
  const digits = onlyDigits(value).slice(0, 14);
  return applyMask(digits, '##.###.###/####-##');
};
